// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".30ec7958b5fd57a994a71fd4be2350a9ec4e75b0.chunk.js";
};